import { IncentiveCategory } from '@varo/graphql-schema-types';
import { IncentiveScreenNames } from 'features/incentive/helpers/incentiveAnalytics';
import { useIncentiveScreenViewed } from 'features/incentive/hooks/useIncentiveAnalytics';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { navigateBack } from 'shared/helpers/backNavigation.helpers';
import EmptyStateScreen from 'shared/patterns/vxl/EmptyStateScreen/EmptyStateScreen';
import theme from 'shared/styles/theme';

interface IncentiveNotAvailableScreenProps {
  incentiveType: IncentiveCategory;
}

function IncentiveNotAvailableScreen({
  incentiveType,
}: IncentiveNotAvailableScreenProps) {
  const { t: translatedText } = useTranslation('incentive', {
    keyPrefix: 'notAvailable',
  });
  const { top } = useSafeAreaInsets();

  useIncentiveScreenViewed({
    screenName: IncentiveScreenNames.NOT_AVAILABLE,
    incentiveType,
  });

  return (
    <View style={[styles.container, { paddingTop: top }]}>
      <EmptyStateScreen
        illustrationKey="PLACEHOLDER_A"
        headlineText={translatedText('headline')}
        bodyText={translatedText('body')}
        actionButtonText={translatedText('goBack')}
        actionOnPress={navigateBack}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default IncentiveNotAvailableScreen;
